<template>
  <section class="Refer_A_Friend">
    <div class="section-space"></div>
    <div class="section-space"></div>
    <div class="container" :style="project == 'wanasatime' ? 'color:white' : ''">
      <div class="text-center">
        <h1 class="mb-0 d-none d-md-block">The more the merrier.</h1>
        <h3 class="mb-0 d-md-none">The more the merrier.</h3>
        <p>
          Refer your friends and save upto 500 {{ country_list.CurrencyCode }}!
          <!-- Refer a friend to
          <span class="text-warning">give</span> ₦ 100 and
          <span class="text-warning">get</span> ₦ 100-->
        </p>
      </div>
      <div v-if="isUserLoggedIn">
        <div class="text-center mt-4">
          <p class="mb-0">Your personal invite code</p>
          <button
            ref="copy"
            v-clipboard:copy="message"
            v-clipboard:success="onCopy"
            class="refer_code"
          >{{userDetails.ReferalCode}}</button>
        </div>

        <div class="text-center mt-4">
          <button class="refer_code_email">
            <a
              target="_blank"
              style="color:#fff;"
              :href="'https://mail.google.com/mail/?view=cm&fs=1&to=&su='+userDetails.mailSubject+'&body='+userDetails.mailBody"
            >Invite your friend via email</a>
          </button>
        </div>
      </div>
      <div class="text-center" style="font-size:20px;" v-else>
        <p class="rounded d-table mx-auto refer_code">
          <a
            v-b-modal.signIn
            @contextmenu="handler($event)"
            class="text-blue"
            style="cursor: pointer; color: #b50201;"
          >
            <u>Login&nbsp;</u>
          </a>Or
          <a
            v-b-modal.signUp
            @contextmenu="handler($event)"
            class="text-blue"
            style="cursor: pointer; color: #b50201;"
          >
            <u>Register&nbsp;</u>
          </a>
          <br />Now to get your MyTiketi referral code.
        </p>
      </div>

      <div class="row border-bottom mt-5">
        <div
          class="col-md-3 align-self-center text-md-left text-center"
        >Get {{ country_list.CurrencyCode }} 100 off, when your friend completes their first transaction using your referral code. Refer 5 friends to save upto {{ country_list.CurrencyCode }} 500.</div>
        <div class="col-md-6 position-relative my-5 my-md-0">
          <div>
            <img
              src="@/assets/img/Refer_A_Friend_left.png"
              alt="Refer-A-Friend"
              class="img-fluid Refer_A_Friend_left d-none d-md-block"
            />
            <img
              src="@/assets/img/Refer_A_Friend_left_mobile.png"
              alt="Refer-A-Friend"
              class="img-fluid Refer_A_Friend_left_mobile d-md-none"
            />
          </div>

          <img src="@/assets/img/Refer_A_Friend_center.png" alt="Refer-A-Friend" class="img-fluid" />
          <div>
            <img
              src="@/assets/img/Refer_A_Friend_right.png"
              alt="Refer-A-Friend"
              class="img-fluid Refer_A_Friend_right d-none d-md-block"
            />
            <img
              src="@/assets/img/Refer_A_Friend_right_mobile.png"
              alt="Refer-A-Friend"
              class="img-fluid Refer_A_Friend_right_mobile d-md-none"
            />
          </div>
        </div>
        <div
          class="col-md-3 align-self-center text-md-left text-center"
        >Your friend gets {{ country_list.CurrencyCode }} 100 off on successfully registering on MyTiketi using your referral code.</div>
      </div>

      <div class="mt-5">
        <p>Terms &amp; Conditions</p>
        <ol class>
          <li>You are eligible to earn referral points under MyTiketi Refer & Win program only when the friends who you have shared the Unique referral codes with, completes a transaction on the MyTiketi platform.</li>
          <li>The referral code is only valid once per user.</li>
          <li>Incase you are a new user on MyTiketi and have never registered on MyTiketi web or app, you will need to first register yourself to generate a unique referral code to share with your friends or family.</li>
          <li>Earned points value is 1 point = 1{{ country_list.CurrencyCode }}.</li>
          <li>All referral credits (discounts / Credits ) will be added to your Mytiketi account and will be visible in the rewards section once you log in to your MyTiketi account on the web or app.</li>
          <li>The100{{ country_list.CurrencyCode }} off per transaction, cannot be clubbed with any other offer or discount.</li>
          <li>This can only be redeemed on transactions made through the MyTiketi website or app and cannot be individually utilised at the partnering cinemas.</li>
          <li>The Credits / Discount codes will only be valid up to 90 days from the date of receipt of the amount.</li>
          <li>The Referral program is purely created to reward MyTiketi Users for spreading love amongst their family and friends and MyTiketi has the right to discontinue this at any time.</li>
          <li>As A MyTiketi user you can have only single / unique login. Creating duplicate emails, signing-in from multiple devices, multiple sign-ins on a device and having more than one MyTiketi Reward Account per user in order to unduly gain referral credits/ discounts is against the spirit of the referral program and MyTiketi holds the right to negate any such rewards if a user is found guilty of doing so.</li>
          <li>This offer is valid for new users only.</li>
        </ol>
      </div>
    </div>
    <div class="section-space"></div>
  </section>
</template>
<script>
import { makeRequest } from "@/helper/internet.js";
import { URL_BASE, BASEURL, PROJECT } from "@/helper/constant.js";
import axios from "axios";
import { EventBus } from "@/main";
import {
  LanguageService,
  CountryService,
  TokenService
} from "@/services/storage.service";
export default {
  name: "ReferAFriend",
  data() {
    return {
      country_list: {
        CountryCity: null,
        CountryCode: null,
        CountryID: null,
        CountryISOCode: null,
        CountryName: null,
        CurrencyCode: null,
        CountryState: null,
        IPAddress: null
      },

      isUserLoggedIn: false,
      project: PROJECT,
      userDetails: {
        LastName: "",
        FirstName: "",
        Email: "",
        Mobile: "",
        Gender: "",
        OTP: "",
        ProfileURL: "",
        CountryCode: "",
        mailSubject: "",
        mailBody: ""
      },
      _userDetails: {
        LastName: "",
        FirstName: "",
        Email: "",
        Mobile: "",
        Gender: "",
        OTP: "",
        ProfileURL: "",
        CountryCode: "",
        mailSubject: "",
        mailBody: ""
      },
      errorMessage: "",
      successMessage: "",
      message: ""
    };
  },
  beforeMount() {
    this.fetchUserDetails();
    this.getAllGetCountryList();
    this.ticketlogo =
      this.project == "ticketak"
        ? "https://www.ticketak.com/static/img/tt-logo.7304160.png"
        : "https://api.mytiketi.com/shareticket/img/logo.png";
  },
  mounted() {
    EventBus.$on("UserLoggedIn", data => {
      this.userDetails = data;
      //this.fetchUserDetails();
      this.isUserLoggedIn = true;
      this.message = this.userDetails.ReferalCodeURL;
      this.referralHistory = this.userDetails.userreflegdata
        ? this.userDetails.userreflegdata
        : [];
      console.log("URL", this.referralHistory);
    });
  },
  methods: {
    getAllGetCountryList: function() {
      makeRequest("/GetCountryCode", "POST", null, {})
        .then(response => {
          const { error, res } = response;
          if (res.data.Status) {
            this.country_list = {
              ...this.country_list,
              ...res.data.Default
            };
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    fetchUserDetails: function() {
      let token = TokenService.getToken();
      makeRequest(`/GetProfile`, "POST", token, null)
        .then(result => {
          this.userDetails = result.res.data;
          this.isUserLoggedIn = true;
          this._userDetails = result.res.data;
          this.message = this.userDetails.ReferalCodeURL;
          this.referralHistory = this.userDetails.userreflegdata
            ? this.userDetails.userreflegdata
            : [];
        })
        .catch(error => {
          console.log(" Error", error);
        });
    },
    onCopy: function(e) {
      this.$toasted.show("Link copied to clipboard");
      setTimeout(() => {
        this.$toasted.clear();
      }, 3000);
    }
  }
};
</script>

<style>
.Refer_A_Friend_left_mobile {
  position: absolute;
  top: -13%;
  left: 38%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.Refer_A_Friend_right_mobile {
  position: absolute;
  bottom: -10%;
  right: 0%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.refer_code {
  font-size: 22px;
  padding: 6px 20px;
  background: transparent;
  border: 1px dashed #979797;
}

.refer_code:focus {
  outline: none;
  background: #d3d3d3;
}

.refer_code_email {
  font-size: 14px;
  color: #fff;
  padding: 9px 20px;
  border-radius: 15px;
  background: #c7000f;
  border: none;
  outline: none;
}

@media (min-width: 767px) and (max-width: 768px) {
  .Refer_A_Friend_right {
    position: absolute;
    top: 51%;
    right: -34px;
    height: auto;
    width: 25%;
  }
  .Refer_A_Friend_left {
    position: absolute;
    top: 9%;
    left: -94px;
    height: auto;
    width: 50%;
  }
}

@media (min-width: 769px) {
  .Refer_A_Friend_right {
    position: absolute;
    top: 49%;
    right: -34px;
    height: auto;
    width: 28%;
  }
  .Refer_A_Friend_left {
    position: absolute;
    top: 9%;
    left: -95px;
    height: auto;
    width: 50%;
  }
}

@media (min-width: 1024px) {
  .Refer_A_Friend_right {
    position: absolute;
    top: 49%;
    right: -34px;
    height: auto;
    width: 28%;
  }
  .Refer_A_Friend_left {
    position: absolute;
    top: 9%;
    left: -130px;
    height: auto;
    width: 50%;
  }
}

@media (min-width: 1200px) {
  .Refer_A_Friend_left {
    position: absolute;
    top: 8%;
    left: -174px;
  }
  .Refer_A_Friend_right {
    position: absolute;
    top: 40%;
    right: -8px;
  }
}
</style>    




// WEBPACK FOOTER //
// src/components/pages/referAFriend.vue